import React, { useContext } from "react"
import { Accordion, Modal } from "react-bootstrap";
import {
  Button,
  InputLabel,
  TextField,
  MenuItem,
  Select,
  AccordionSummary,
  AccordionDetails
} from "@mui/material";
import AsyncSelect from "react-select/async";
import language from "../../../nls/language.json";
import Context from "../../../context/Context";
import { ExpandMore } from "@mui/icons-material";
import '../Combinations.css';
import { NumberInput } from "@mui/base/Unstable_NumberInput/NumberInput";

export default function AddCombinationsModal({
  showModalAdd,
  setShowModalAdd,
  handleAddCombinacoes,
  setQtPiece,
  MAX_PIECE,
  selectedAddCombination,
  grupoPecas,
  grupoProdutos,
  postCombination,
  checkSaveBtn,
  qtPiece
}) {
  const {
    selectedCountry,
    getFurnace
  } = useContext(Context);

  return (
    <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          {language[selectedCountry.name].Cadastro.combinacoes.modal.adicionar.title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div>
          <div className="d-flex flex-nowrap">
            <InputLabel className="d-flex flex-column me-1 w-75 form-label">
              {language[selectedCountry.name].Cadastro.combinacoes.modal.adicionar.labels.combinacao}
              <TextField
                className="mb-3"
                name="comb_Nome"
                required
                fullWidth
                id="outlined-basic"
                placeholder="Nome da combinação"
                onChange={({ target }) => handleAddCombinacoes(target)}
              />
            </InputLabel>

            <InputLabel className="d-flex flex-column w-25 form-label">
              {language[selectedCountry.name].Cadastro.combinacoes.modal.adicionar.labels.aproveitamento}
              <Select
                name="aproveitamento"
                value={selectedAddCombination.tipoCombinacao.aproveitamento}
                onChange={({ target }) => handleAddCombinacoes(target)}
              >
                <MenuItem value={0}>0</MenuItem>
                <MenuItem value={0.5}>0.5</MenuItem>
                <MenuItem value={1}>1</MenuItem>
              </Select>
            </InputLabel>
          </div>

          {/* -------------------- SELEÇÃO DO FORNO -------------------- */}
          <InputLabel className="form-label" children={language[selectedCountry.name].Cadastro.combinacoes.modal.adicionar.labels.forno} />

          <AsyncSelect
            label="Forno"
            className="mb-2"
            required
            cacheOptions
            defaultOptions
            placeholder="Forno"
            loadOptions={getFurnace}
            getOptionLabel={(e) => e.forno_Name}
            getOptionValue={(e) => e.forno_Name}
            onChange={(e) =>
              handleAddCombinacoes({
                name: "forno",
                value: e.forno_Name
              })
            }
          />

          {/* -------------------- QTDE DE PEÇAS + NOVO CAMPO BOMBA -------------------- */}
          <div className="d-flex flex-row gap-9 mt-2 justify-center">
            <div className="d-flex flex-column align-items-start w-25 mt-3"  >
              <InputLabel className="form-label">
                {language[selectedCountry.name].Cadastro.combinacoes.modal.adicionar.labels.qPeca}
              </InputLabel>

              <Select
                className="w-100"
                value={qtPiece}
                onChange={({ target }) => {
                  handleAddCombinacoes(
                    {
                      name: "grupo_peca",
                      value: target.value
                    },
                    "GRUPO_PECA"
                  );
                  setQtPiece(target.value);
                }}
              >
                {[...Array(MAX_PIECE)].map((_, i) => (
                  <MenuItem key={`qtPiece-${i}`} value={i + 1}>
                    {i + 1}
                  </MenuItem>
                ))}
              </Select>
            </div>

            {/* -------- NOVO INPUT BOMBA -------- */}
            <div className="d-flex flex-column align-items-start jus gap-2 mt-2">
              <InputLabel className="form-label">Bomba</InputLabel>
              <TextField
                type="number"
                name="bomba"
                placeholder="0"
                onChange={({ target }) =>
                  handleAddCombinacoes({
                    name: "DifBomba",
                    value: Number(target.value)
                  })
                }
                inputProps={{ min: 0 }}
              />
            </div>
          </div>

          {/* -------------------- GRUPO PEÇA + GRUPO PRODUTO -------------------- */}
          <InputLabel className="mt-3 form-label" children={language[selectedCountry.name].Cadastro.combinacoes.modal.adicionar.labels.produto} />

          <Accordion
            disabled={!selectedAddCombination.tipoCombinacao.forno}
            expanded={!!selectedAddCombination.tipoCombinacao.forno}
          >
            <AccordionSummary className="header-flex bg-light">
              <p className="mb-0 fw-bold">{language[selectedCountry.name].Cadastro.combinacoes.modal.adicionar.labels.grupoPeca}</p>
            </AccordionSummary>

            <AccordionDetails className="p-3">
              {selectedAddCombination.combinacao.map((item, i) => (
                <div className="d-flex flex-row m-1 gap-1 form-label" key={`combinacao-grupo_peca-${i}`}>
                  <Select
                    className="w-100"
                    value={item?.grupo_peca}
                    onChange={({ target }) =>
                      handleAddCombinacoes(
                        {
                          name: "grupo_peca",
                          value: target.value
                        },
                        "GRUPO_PECA_BY_ITEM",
                        i
                      )
                    }
                  >
                    {grupoPecas.map((item, index) => (
                      <MenuItem key={`grupoPecas-${index}`} value={item.prodGrupo_GrupoNome}>
                        {item.prodGrupo_GrupoNome}
                      </MenuItem>
                    ))}
                  </Select>

                  <Select
                    className="w-100"
                    value={item?.grupo_produto || ""}
                    displayEmpty
                    onChange={({ target }) =>
                      handleAddCombinacoes(
                        {
                          name: "grupo_produto",
                          value: target.value
                        },
                        "GRUPO_PECA_BY_ITEM",
                        i
                      )
                    }
                  >
                    <MenuItem value="" disabled>Grupo</MenuItem>
                    {grupoProdutos.map((item, index) => (
                      <MenuItem key={`grupoProduto-${index}`} value={item.prodGrupo_GrupoNome}>
                        {item.prodGrupo_GrupoNome}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="text" sx={{ marginRight: 2 }} onClick={() => setShowModalAdd(false)}>
          {language[selectedCountry.name].Cadastro.combinacoes.modal.adicionar.btnCancelar}
        </Button>

        <Button
          variant="contained"
          onClick={() => postCombination(selectedAddCombination)}
          disabled={checkSaveBtn(selectedAddCombination.combinacao)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.modal.adicionar.btnSalvar}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
